// @ts-nocheck
import { Component, Input, OnInit } from '@angular/core';
import { TableListComponent } from '../../../fields/table-list/table-list.component';
import { ParallelTableService } from './parallel-table.service';

interface IItemNode {
  data: {
    [key: string]: string;
  };
  children?: IItemNode[];
}

@Component({
  selector: 'legalboxplus-parallel-table',
  templateUrl: './parallel-table.component.html',
  styleUrl: './parallel-table.component.scss',
  imports: [TableListComponent],
})
export class ParallelTableComponent implements OnInit {
  public loadPage = false;
  public processId!: number;
  public dataAttr;
  public line;
  public lineremove;
  public legalRequestEdit!: { [key: string]: any };
  public dataProcess;
  public tasks: any;
  public field: any;
  public data: any;
  public taskId!: number;
  public editParallel: boolean = true;

  public parallelChildrenTasks: any[] = [];

  constructor(private parallelTableService: ParallelTableService) {}

  @Input() configuration;

  @Input('cardData') cardInfo;
  @Input('entityData') set modulesConfig(data) {}

  private subFormModuleInstance: any;
  private dynamicFormService: any;
  @Input('subFormModuleInstance') set subFormModuleInstanceController(fn) {
    this.subFormModuleInstance = fn;
  }

  @Input('dynamicFormService') set dynamicFormServiceController(fn) {
    this.dynamicFormService = fn;
  }

  @Input('dataProcess') set dataSet(data) {
    if (data?.parallelChildrenTasks && data?.parallelChildrenTasks.length > 0) {
      this.parallelChildrenTasks = data?.parallelChildrenTasks;
    }
  }

  @Input('dataAttr') set dataAt(data) {
    this.dataAttr = data;
  }

  ngOnInit(): void {
    this.processId = this.dataAttr.processNumber;
    this.taskId = this.dataAttr.bpmIdCard;

    this.getTasksParallelByTaskFatherId(this.taskId);

    this.field = this.configuration?.fields[0][0];

    this.dynamicFormService.eventEmitter.subscribe((event) => {
      if (event.event == 'parallelInsert') {
        if (!this.parallelChildrenTasks.some((item) => item === event.value))
          this.parallelChildrenTasks.push(event.value);
      } else if (event.event == 'parallelRemove') {
        this.parallelChildrenTasks = this.parallelChildrenTasks.filter((id) => id !== event.value);
      }
      setTimeout(() => this.getTasksParallelByTaskFatherId(this.taskId), 1000);
    });
  }

  public eventParallelEmitter(event) {
    this.subFormModuleInstance('parallelEmmiter', 'eventEmmiter', event.id);
  }

  private getTasksParallelByTaskFatherId(taskId: number) {
    this.parallelTableService
      .getTasksParallelByTaskFatherId(taskId, this.dataAttr.userId)
      .subscribe((res: any) => {
        if (res) {
          this.parallelChildrenTasks = res.parallelChildrenTasks || [];
          this.getTasks();
        }
      });
  }

  private getTasks() {
    this.parallelTableService
      .getTasksByIds<Array<any>>(this.parallelChildrenTasks)
      .subscribe((res: Array<any>) => {
        if (res && res.length > 0) {
          res.sort((a, b) => (a.id > b.id ? 1 : -1));

          this.tasks = res;
        }
      });
  }
}
